import React from 'react';
import { Button } from '@lux/buttons';
import { Size } from '@lux/dialog';
import { ControlsCloseS } from '@lux/icons';
import { Preset, Text } from '@lux/text';
import { Title, TitlePreset } from '@lux/title';
import { FunctionColor } from '@lux/tokens';
import { UrlSource, useConfig } from '@browsing/config';
import { tracker } from '../../tracking';
import { setEducationalLocationInSessionStorage } from '../../utils';
import { Benefit } from './benefit';
import * as S from './styles';
var onSwipe = function () {
    tracker.track('plus_educationStep_swipe');
};
export var EducationalDialog = function (_a) {
    var benefits = _a.benefits, context = _a.context, cta = _a.cta, description = _a.description, footer = _a.footer, isShown = _a.isShown, logoLightTheme = _a.logoLightTheme, onClose = _a.onClose, title = _a.title;
    var config = useConfig();
    var baseUrl = config.getUrl(UrlSource.BASE);
    var successUrl = encodeURIComponent("".concat(baseUrl, "plus-membership/signup/success"));
    var errorUrl = encodeURIComponent(baseUrl);
    var ctaLink = "".concat(cta === null || cta === void 0 ? void 0 : cta.targetAction, "?context=").concat(context, "&zetsr=").concat(successUrl, "&zetner=").concat(errorUrl);
    var onCTAClick = function () {
        tracker.track('plus_educationStep_beginSignUpPlus', { lastPlusCTA: context });
        setEducationalLocationInSessionStorage();
    };
    return (React.createElement(S.Dialog, { closeDialog: onClose, isShown: isShown, size: Size.S, sizeSm: Size.L, rawDialogBody: true },
        React.createElement(S.Header, null,
            React.createElement(S.CloseWrapper, null,
                React.createElement("img", { alt: "", src: logoLightTheme === null || logoLightTheme === void 0 ? void 0 : logoLightTheme.uri }),
                React.createElement("button", { onClick: onClose, onKeyPress: onClose, tabIndex: -1, type: "button" },
                    React.createElement(ControlsCloseS, { "aria-hidden": "true" }))),
            React.createElement(Title, { preset: TitlePreset.S, presetSm: TitlePreset.M, presetLg: TitlePreset.L }, title)),
        React.createElement(S.CarouselWrapper, null,
            React.createElement(S.Carousel, { onScroll: onSwipe, visibleItems: 1, visibleItemsXs: 3, visibleItemsSm: 4 }, benefits.map(function (_a, index) {
                var availability = _a.availability, benefitDescription = _a.description, primaryImage = _a.primaryImage, subtitle = _a.subtitle, benefitTitle = _a.title;
                return (React.createElement(Benefit
                // eslint-disable-next-line react/no-array-index-key
                , { 
                    // eslint-disable-next-line react/no-array-index-key
                    key: index, availability: availability, description: benefitDescription, image: primaryImage === null || primaryImage === void 0 ? void 0 : primaryImage.uri, subtitle: subtitle, title: benefitTitle }));
            }))),
        React.createElement(S.Footer, null,
            React.createElement("div", null,
                React.createElement(Text, { color: FunctionColor.function0, preset: Preset.S },
                    React.createElement("span", { dangerouslySetInnerHTML: { __html: description } })),
                React.createElement(Button, { disabled: (cta === null || cta === void 0 ? void 0 : cta.isDisabled) === 'true', fullWidth: true, href: ctaLink, link: true, onClick: onCTAClick }, cta === null || cta === void 0 ? void 0 : cta.text),
                React.createElement(Text, { color: FunctionColor.function0, preset: Preset.S },
                    React.createElement("span", { dangerouslySetInnerHTML: { __html: footer } }))))));
};
